import select from './select';
import slugify from "slugify";

const gaProductListImpressions = (listSelector='[data-ec-product-list]')=>{
    try {
        const recommendedProductLists = select.all(listSelector);
        if(!!recommendedProductLists && recommendedProductLists.length){
            recommendedProductLists.forEach((list)=>{
                const listParentId = list.dataset?.ecProductListParentId || '';
                const itemListName = `${list.dataset?.ecProductList || ''}${!!listParentId ? ` - ${listParentId}` : ''}`;
                let listItemsDLArray = [];
                const listItems = select.all('[data-ec-product-list-item]', list);
                if(!!listItems && listItems.length){
                    listItems.forEach((listItem, i)=>{
                        listItemsDLArray.push(
                            {
                                item_id: listItem.dataset?.ecProductListItem || '',
                                item_name: listItem.dataset?.ecProductListItemName || '',
                                item_brand: listItem.dataset?.ecProductListItemBrand || '',
                                item_list_name: itemListName,
                                index: listItem.dataset?.ecProductListItemIndex || i + 1,
                                quantity: 1
                            }
                        );
                    });
                    gtag("event", "view_item_list", {
                        item_list_id: slugify(itemListName, {lower: true}),
                        item_list_name: itemListName,
                        items: listItemsDLArray,
                    });
                }
            });
        }
    }
    catch (e) {
        console.error(e);
    }
};

export {gaProductListImpressions};
